var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaDisplayAdsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-display-ads-icon_svg__a",
    d: "M0 0h41.613v52.258H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-display-ads-icon_svg__c",
    d: "M0 60h57.097V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.42 51.29a3.871 3.871 0 01-3.872-3.87V13.298C5.512 17.369 0 25.699 0 35.323 0 48.95 11.049 60 24.677 60c7.538 0 14.281-3.383 18.808-8.71H17.42z",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.58)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-display-ads-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-display-ads-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.226 52.258H4.839A4.844 4.844 0 010 47.419V4.84a4.844 4.844 0 014.839-4.84h31.935a4.844 4.844 0 014.839 4.84v25.16h-1.936V4.84c0-1.601-1.302-2.904-2.903-2.904H4.84A2.907 2.907 0 001.935 4.84v42.58c0 1.6 1.303 2.903 2.904 2.903h18.387v1.936z",
    fill: "#020303",
    mask: "url(#ea-display-ads-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M31.935 44.516H16.451V7.742h33.871V30h-1.935V9.677h-30v32.904h13.548z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.194 34.839h-1.936c0-1.089-1.029-1.936-1.935-1.936h-1.936c-.37-.58-1.326-.968-1.935-.968h-1.936v-6.774a1.935 1.935 0 10-3.87 0v14.516l-1.294 1.241-2.53-3.92c-1.548-2.133-3.919-.936-3.919 0 0 0 2.936 9.368 3.357 10.027.676 1.057 3.417 3.438 3.417 4.265v3.871h14.517v-2.903c0-1.303 1.935-2.88 1.935-4.839V36.774c0-1.089-1.029-1.935-1.935-1.935",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.161 55.161h-1.935v-2.903c0-.857.467-1.625.963-2.437.478-.784.972-1.595.972-2.402V36.774c0-.534-.585-.968-.968-.968H51.29v-.967c0-.535-.585-.968-.968-.968h-2.466l-.286-.448c-.15-.238-.758-.52-1.119-.52h-.967v4.839h-1.936v-12.58a.969.969 0 00-1.935 0V40.09l-2.439 2.339-3.165-4.908c-.366-.503-.856-.782-1.374-.745-.33.02-.58.154-.706.26 1.34 4.26 2.874 8.95 3.161 9.492.2.312.773.92 1.326 1.508 1.424 1.51 2.229 2.406 2.229 3.253v3.871h-1.936v-3.786c-.176-.392-1.126-1.4-1.7-2.012-.672-.713-1.252-1.327-1.565-1.818-.425-.667-2.353-6.713-3.464-10.258l-.045-.29c0-.851.71-1.654 1.765-1.998 1.121-.366 2.736-.18 3.906 1.43l1.922 2.978.15-.143V25.161c0-1.6 1.302-2.903 2.902-2.903 1.601 0 2.904 1.303 2.904 2.903v5.807h.967c.745 0 1.735.354 2.38.967h1.491c1.096 0 2.292.76 2.73 1.936h1.141c1.374 0 2.904 1.192 2.904 2.903V47.42c0 1.351-.697 2.492-1.257 3.41-.318.522-.679 1.115-.679 1.429v2.903z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ea-display-ads-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-display-ads-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-display-ads-icon_svg__d)",
    d: "M47.42 37.742h1.935v-4.839h-1.936zM51.29 38.71h1.936v-3.871H51.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#ea-display-ads-icon_svg__d)",
    d: "M37.742 59.032h18.387v-4.838H37.742z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#ea-display-ads-icon_svg__d)",
    d: "M57.097 59.032H55.16v-3.87H38.71v3.87h-1.935v-5.806h20.323zM30 5.806h7.742V3.871H30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#ea-display-ads-icon_svg__d)",
    d: "M32.923 22.258H21.31l-.02-9.677h11.614z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.276 21.29h9.677l-.016-7.742h-9.678l.017 7.742zm11.617 1.936H20.344l-.024-11.613h13.548l.025 11.613zM35.806 15.484h10.646v-1.936H35.806zM35.806 19.355h7.742v-1.936h-7.742zM20.323 27.097H33.87V25.16H20.323zM20.323 30.968H33.87v-1.936H20.323zM20.323 34.839h7.742v-1.936h-7.742z",
    fill: "#020303",
    mask: "url(#ea-display-ads-icon_svg__d)"
  }))));
}
export default SvgEaDisplayAdsIcon;